// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.RentalManagerUserPropertyFloorPlanDeleteWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

interface DeleteParams {
  floorPlanId: string;
}

export const RentalManagerUserPropertyFloorPlanDeleteWebApiHandler_delete_Path =
  '/api/web/v1/users/properties/floorPlans/delete';

/**
 * Delete floor plan of a property
 * @deprecated
 */
export const RentalManagerUserPropertyFloorPlanDeleteWebApiHandler_delete = (
  getParams: DeleteParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DeleteParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanDeleteWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
